import Vue from "vue";
import PurchaseOrderTransformer from "@/transformers/purchase/purchaseOrders";
import moment from "moment";

function urlParamsTransformer({
  dateFrom,
  providerType,
  provider,
  revi,
  asc,
  searchQuery: text,
  page,
  pageSize,
  warehouseId,
}) {
  let params = {
    page,
    size: pageSize,
    iwarehouse: warehouseId,
    ascending_order: asc ? true : undefined,
    revi: revi ? revi : undefined,
    provider: provider ? provider : undefined,
    'provider_type': providerType,
    from: dateFrom
      ? moment(dateFrom).format("YYYY/MM/DD")
      : undefined,
    // delivery_date: deliveryDate
    //   ? moment(deliveryDate).format("YYYY/MM/DD")
    //   : undefined,
    text,
  };

  if (!text) {
    delete params.text;
  }
  return params;
}

export default (fetchOptions) => {
  const params = fetchOptions ? urlParamsTransformer(fetchOptions) : null;
  return Vue.$http
    .get("purchase/list_orders/", { params })
    .then((response) => {
      const { results, ...paginationInfo } = response.data;
      const purchaseOrders = PurchaseOrderTransformer.fetchCollection(results);
      return { purchaseOrders, paginationInfo };
    })
    .catch((error) => {
      const response = error.response;
      if (response && response.status !== 404) {
        throw error;
      } 
    });
};



// WEBPACK FOOTER //
// ./src/services/purchase/fetchPurchaseOrders.js